import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { TRANSACTION_HISTORY, TRANSACTION_HISTORY_EDITABLE, TRANSACTION_HISTORY_FILTER, TRANSACTION_HISTORY_SEARCH, TRANSACTION_HISTORY_SORT, TRANSACTION_HISTORY_ALL_TXNS, TRANSACTION_HISTORY_ALL_TXNS_ERROR, TRANSACTION_HISTORY_ALL_TXNS_LOADER, TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR, } from "@frameworks/web/redux/interfaces/Reports/iTransactionHistory";
class TransactionHistoryActions extends OnePlatformCommonActions {
    getTransactionHistory(transactionHistory, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY,
            payload: { transactionHistory },
            reducerName: type,
        });
    }
    setSearchData(search, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_SEARCH,
            payload: { SearchData: search },
            reducerName: type,
        });
    }
    setFilterData(filters, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_FILTER,
            payload: { FilterData: filters },
            reducerName: type,
        });
    }
    setSortData(sortData, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_SORT,
            payload: { SortData: sortData },
            reducerName: type,
        });
    }
    allEditableTxns(editableTxns, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_EDITABLE,
            payload: { editableTxns },
            reducerName: type,
        });
    }
    getAllTransactionHistory(transactionHistory, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_ALL_TXNS,
            payload: { allTransactionHistory: transactionHistory },
            reducerName: type,
        });
    }
    allTransactionHistoryLoader(loader, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_ALL_TXNS_LOADER,
            payload: { allTxnLoader: loader },
            reducerName: type,
        });
    }
    allTransactionHistoryError(error, type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_ALL_TXNS_ERROR,
            payload: { allTxnError: error },
            reducerName: type,
        });
    }
    allTransactionHistoryHideError(type) {
        this.dispatch({
            type: TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR,
            reducerName: type,
        });
    }
}
export default TransactionHistoryActions;
